import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

function SuperuserPasswordForm({ superuser, formErrors, handleChange, renderError }) {
  const [pwdShow, setPwdShow] = useState(false);
  const [confirmShow, setConfirmShow] = useState(false);

  return (
    <>
      <Form.Group>
        <div className="position-relative">
          <Form.Control
            className={formErrors && formErrors.password ? 'bo-input bo-input-error' : 'bo-input'}
            type={pwdShow ? 'text' : 'password'}
            name="password"
            id="password"
            placeholder="Password"
            value={superuser.password ? superuser.password : ''}
            onChange={e => handleChange(e)}
          />
          <div className="bo-eye-wrapper" onClick={() => setPwdShow(!pwdShow)}>
            <FontAwesomeIcon icon={pwdShow ? faEyeSlash : faEye} />
          </div>
        </div>
        {'password' in formErrors ? renderError(formErrors.password) : ''}
      </Form.Group>
      <Form.Group>
        <div className="position-relative">
          <Form.Control
            className={
              formErrors && formErrors.confirmPassword ? 'bo-input bo-input-error' : 'bo-input'
            }
            type={confirmShow ? 'text' : 'password'}
            name="confirmPassword"
            id="confirmPassword"
            placeholder="Confirm password"
            value={superuser.confirmPassword ? superuser.confirmPassword : ''}
            onChange={e => handleChange(e)}
          />
          <div className="bo-eye-wrapper" onClick={() => setConfirmShow(!confirmShow)}>
            <FontAwesomeIcon icon={confirmShow ? faEyeSlash : faEye} />
          </div>
        </div>
        {'confirmPassword' in formErrors ? renderError(formErrors.confirmPassword) : ''}
      </Form.Group>
    </>
  );
}

export default SuperuserPasswordForm;
